module.exports = __webpack_public_path__ + "img/15.33623270.jpg";